<template>
  <div style="text-align: center;">
    <div class="paging clearfix">
      <div class="page-size fl"
           v-if="isShowTotal">共{{total}}条</div>
      <ul class="page-list fl clearfix">
        <li :class="`page-run ${currentPage == 1 ? 'disabled' : ''}`"
            @click="changePage(currentPage-1)">
          <i class="iconfont icon-jiantou_liebiaoxiangzuo" />
        </li>
        <li :class="{'active':currentPage==item.val}"
            :key="i"
            v-for="(item, i) in pagelist"
            v-text="item.text"
            @click="changePage(item.val)"></li>
        <li :class="`page-run ${pageSize * currentPage >= total ? 'disabled' : ''}`"
            @click="changePage(currentPage+1)">
          <i class="iconfont icon-jiantou_liebiaoxiangyou" />
        </li>
      </ul>
      <div class="page-jump fl"
           v-if="isShowJumper && total > 0">
        <span>前往</span>
        <input class="input"
               type="text"
               v-model="toPage"
               @keydown="submit(toPage,$event)">
        <span>页</span>
        <!-- <button  @click="changePage(toPage)">确定</button> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Paging",
    // props:[
    //    'name'
    // ],
    // prop验证
    props: {
      name: String,
      pageSize: {
        type: Number,
        default: 10
      },
      total: {
        type: Number,
        default: 0
      },
      currentPage: {
        type: Number,
        default: 1
      },
      layout: {
        type: String
      }
    },
    data() {
      return {
        isShowJumper: false,
        isShowTotal: false,
        toPage: "", //跳转到x页
        pageGroup: 10 //可见分页数量 默认10个分页数
      }
    },
    created: function () {
      // console.log("created")
      this.isShowTotal = this.layout.indexOf("total") !== -1
      this.isShowJumper = this.layout.indexOf("jumper") !== -1
    },
    mounted: function () {
      // console.log("mounted", this.layout)
    },
    computed: {
      totalPage: function () {
        return Math.ceil(this.total / this.pageSize)
      },
      pagelist: function () {
        var list = []
        var count = Math.floor(this.pageGroup / 2),
          center = this.currentPage
        var left = 1,
          right = this.totalPage

        if (this.totalPage > this.pageGroup) {
          if (this.currentPage > count + 1) {
            if (this.currentPage < this.totalPage - count) {
              left = this.currentPage - count
              right = this.currentPage + count - 1
            } else {
              left = this.totalPage - this.pageGroup + 1
            }
          } else {
            right = this.pageGroup
          }
        }

        // 遍历添加到数组里
        while (left <= right) {
          list.push({
            text: left,
            val: left
          })
          left++
        }
        return list
      }
    },
    methods: {
      // 回车事件
      submit(toPage, e) {
        // console.log('e.keyCode',toPage,e.keyCode)
        // key.Code === 13表示回车键
        if (e.keyCode === 13) {
          //逻辑处理
          this.changePage(toPage)
        }
      },
      changePage: function (idx) {
        window.scrollTo(0, 0)
        if (idx != this.currentPage && idx > 0 && idx <= this.totalPage) {
          // 触发父组件事件  pageChange会转换成小写pagechange
          this.$router.push({
            query: {
              page: Number(idx)
            }
          })
          this.$emit("change", { curPage: Number(idx) })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .paging * {
    font-weight: normal;
  }
  .paging {
    padding: 20px;
    display: inline-block;
  }
  * {
    padding: 0;
    margin: 0;
  }
  .fl {
    float: left;
  }
  .clearfix:after {
    display: block;
    content: "";
    clear: both;
  }
  .page-size {
    height: 30px;
    line-height: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }
  .page-run {
    padding: 0 8px;
    height: 30px;
    line-height: 30px;
  }
  .page-run.disabled {
    color: #bbb;
    cursor: not-allowed;
  }
  .page-run .iconfont {
    font-size: 20px;
  }
  .page-run .page-jump {
    height: 28px;
    line-height: 28px;
    margin-left: 20px;
  }
  .page-jump .input {
    height: 100%;
    box-sizing: border-box;
    width: 48px;
    padding: 0 10px;
    border: 1px solid #dcdfe6;
    margin: 0 4px;
    border-radius: 4px;
    vertical-align: middle;
  }
  .page-jump span {
    vertical-align: middle;
  }
  ul {
    list-style: none;
  }
  ul li {
    float: left;
    color: #444;
    background: #fff;
    padding: 5px 12px;
    cursor: pointer;
    border-radius: 4px;
    /* margin: 0 5px; */
  }
  ul li + li {
    margin-left: 12px;
  }
  ul > li.active {
    background: #003e8d;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Paging.vue